<template>
  <div id="app">
    <!-- 導航列 -->
    <nav class="navbar">
      <div class="nav-container">
        <!-- Logo區域 -->
        <div class="nav-logo">
          <div class="logo-icon">
            <div class="logo-cube">
              <div class="cube-face"></div>
              <div class="cube-face"></div>
              <div class="cube-face"></div>
              <div class="cube-face"></div>
              <div class="cube-face"></div>
              <div class="cube-face"></div>
            </div>
          </div>
          <span class="logo-text">CC輔助商城</span>
        </div>

        <!-- 導航選單 -->
        <ul class="nav-menu" :class="{ active: isMenuOpen }">
          <li class="nav-item">
            <a href="#" class="nav-link" @click="setActiveLink('home')">
              <span class="link-text">首頁</span>
              <span class="link-underline"></span>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="#products"
              class="nav-link"
              @click="setActiveLink('products')"
            >
              <span class="link-text">產品展示</span>
              <span class="link-underline"></span>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="#features"
              class="nav-link"
              @click="setActiveLink('features')"
            >
              <span class="link-text">功能特色</span>
              <span class="link-underline"></span>
            </a>
          </li>
          <li class="nav-item">
            <a href="#about" class="nav-link" @click="setActiveLink('about')">
              <span class="link-text">關於我們</span>
              <span class="link-underline"></span>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="#contact"
              class="nav-link"
              @click="setActiveLink('contact')"
            >
              <span class="link-text">聯絡我們</span>
              <span class="link-underline"></span>
            </a>
          </li>
        </ul>

        <!-- 行動裝置選單按鈕 -->
        <div class="nav-hamburger" @click="toggleMenu">
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
        </div>
      </div>
    </nav>

    <!-- 主要內容區域 -->
    <main class="main-content">
      <!-- 這裡放置您的頁面內容 -->
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="footer">
      <div class="footer-container">
        <!-- Footer主要內容 -->
        <div class="footer-content">
          <!-- 公司資訊 -->
          <div class="footer-section">
            <div class="footer-logo">
              <div class="logo-icon">
                <div class="logo-cube">
                  <div class="cube-face"></div>
                  <div class="cube-face"></div>
                  <div class="cube-face"></div>
                  <div class="cube-face"></div>
                  <div class="cube-face"></div>
                  <div class="cube-face"></div>
                </div>
              </div>
              <span class="logo-text">CC輔助商城</span>
            </div>
            <p class="footer-description">
              創新遊戲外掛科技<br />為您的遊戲體驗帶來無限可能。
            </p>
          </div>

          <!-- 聯絡資訊 -->
          <div class="footer-section">
            <h3 class="footer-title">聯絡我們</h3>
            <div class="contact-info">
              <div class="contact-item">
                <span class="contact-icon">💬</span>
                <a
                  href="https://lin.ee/GwsPMQw"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="line-link"
                >
                  加入官方LINE客服
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer底部 -->
        <div class="footer-bottom">
          <div class="footer-divider"></div>
          <div class="footer-bottom-content">
            <div class="copyright">
              <p>&copy; 2025 EX遊戲外掛. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isMenuOpen: false,
      activeLink: "home",
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    setActiveLink(link) {
      this.activeLink = link;
      this.isMenuOpen = false;
    },
  },
};
</script>
<style>
/* 這是全域樣式，它會正確地應用到 html 和 body 上 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  /* 這是解決左右留白的最終手段 */
  overflow-x: hidden;
}
</style>

<style scoped src="@/assets/Css/app.css"></style>
